export enum ActionTypes {
  GET_MAKES = '[Vehicle] GetMakes',
  GET_MODELS = '[Vehicle] GetModelsData',
  GET_UPDATED_AT = '[Vehicle] GetUpdatedAt',
}

export class GetMakes {
  static readonly type = ActionTypes.GET_MAKES;
}

export class GetUpdatedAt {
  static readonly type = ActionTypes.GET_UPDATED_AT;
}

export class GetModelsData {
  static readonly type = ActionTypes.GET_MODELS;

  constructor(public payload: { make: string }) {
  }
}

